import { useEffect, useState } from "react";
import useQueryData from "hooks/useQueryData";
import { GET_LATEST_ORG_REPO_ACTIVITY } from "graphql/queries";

/**
 * useLatestActivityOfRepos
 *
 * @param {String}  organizationId
 * @param {Array}   repositories
 * @param {Boolean} skip
 */
export default function useLatestActivityOfRepos({ organizationId, repositories, skip }) {
  const [data, setData] = useState();

  const {
    loading,
    data: response,
    error,
  } = useQueryData({
    queryName: GET_LATEST_ORG_REPO_ACTIVITY,
    keyName: "latestOrgRepoActivity",
    skip: skip,
    variables: { organizationId, repositories },
  });

  useEffect(() => {
    if (response) {
      setData(response.latestOrgRepoActivity);
    }
  }, [response]);

  return {
    loading,
    data,
    error,
  };
}
